import type React from 'react';

import { AdvertisementPublicData } from '@cineamo/api/helpers/advertisement-helper';

import AdvertisementCreative from '@cineamo/ui/src/advertisement/AdvertisementCreative';

import { AdvertisementRenderLink, DefaultAdvertisementLink, resolveAdvertisementLinkTarget } from './link';

type BannerAdvertisementProps = {
    onClose: () => void;
    onClick: () => void;
    advertisement: AdvertisementPublicData;
    // Defaults to a plain `<a>` — hosts with locale-aware, typed routing must inject their own.
    renderLink?: AdvertisementRenderLink;
};

const BannerAdvertisement: React.FC<BannerAdvertisementProps> = ({
    onClose,
    onClick,
    advertisement,
    renderLink = DefaultAdvertisementLink
}) => {
    if (!advertisement.topBannerImageUrl && !advertisement.topBannerDesktopImageUrl) {
        return null;
    }

    const target = resolveAdvertisementLinkTarget(advertisement);
    const adName = advertisement.contentName ?? advertisement.advertiserName ?? '';

    return (
        <div className="relative">
            <AdvertisementCreative
                src={advertisement.topBannerDesktopImageUrl ?? advertisement.topBannerImageUrl ?? ''}
                mobileSrc={advertisement.topBannerImageUrl}
                alt={`${adName} Advertisement Banner`}
                width={1920}
                height={120}
                imageClassName="w-full h-auto"
                closeClassName="absolute top-4 right-4"
                onClose={onClose}
                wrapLink={(children) => renderLink({ target, onClick, children })}
            />
        </div>
    );
};

export default BannerAdvertisement;
